import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MessageService } from '../message.service';
import { Router } from '@angular/router';
import { AngularGridInstance, Column, Formatters, GridOption } from 'angular-slickgrid';
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NotifierService } from 'angular-notifier';
import { RestApiService } from '../rest-api.service';
import { Subject } from 'rxjs';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-view-ticket',
  templateUrl: './view-ticket.component.html',
  styleUrls: ['./view-ticket.component.css']
})
export class ViewTicketComponent implements OnInit {

  ticketTypeLoaded = false;
  displayed = true;
  folderDisplayed = true;
  cat = [];
  step: string;
  assignGroupLength: number;
  typeChecked: string;
  columnDefinitions = [];
  gridOptions: GridOption;
  gridOptions1: GridOption;
  gridOptions3: GridOption;
  gridOptions4: GridOption;
  gridOptions2: GridOption;
  dataset: any[];
  angularGrid: AngularGridInstance;
  angularGrid1: AngularGridInstance;
  angularGrid2: AngularGridInstance;
  angularGrid3: AngularGridInstance;
  angularGrid4: AngularGridInstance;
  totalData: number;
  selectedTitles = [];
  selectedTitles2 = [];
  gridObj: any;
  gridObj1: any;
  gridObj2: any;
  gridObj3: any;
  gridObj4: any;
  show: boolean;
  selected: number;
  ticketId: string;
  // tType: string;
  defaultStatus = false;
  defaultUser = false;
  defaultNextUser = false;
  name: string;
  desc: string;
  brief: string;
  rDate: string;
  dDate: string;
  comment: string;
  priority: string;
  ticketCreated = false;
  percent: number;
  canForward = false;

  @ViewChild('content') private content;
  ticketTypes: any;
  solution: string;
  types = [];
  rca: string;
  private notifier: NotifierService;
  respObject: any;
  private clientId: number;
  assignedUser: any;
  assignedGroup: any;
  currentUser: string;
  currentGroup: string;
  groups = [];
  supportGroupSelected: number;
  statusSelected: number;
  users = [];
  status = [];
  userSelected: number;
  assignee_copy: string;
  private groupDetails: any;
  private tId: any;
  lastCatId: number;
  lastParentId: number;
  totalItems: number;
  private statusIndex: any;
  statusName: string;
  private createbyid: any;
  private wfcresultId: any;
  respTime: number;
  comments = [];
  assignedToMe = false;
  closedticket = false;
  endIndicator = true;
  slaViolated = false;
  logs = [];
  private gid: number;
  private gid_copy: number;
  private aid: any;
  count: number;
  solutions = [];
  private modalReference: NgbModalRef;
  private folderClicked: any;
  createdByMe = false;
  attachments = [];
  attachment = [];
  uploadButtonName = 'Upload File';
  fileUploadUrl: string;
  formData: any;
  menus = [];
  ticketTab = true;
  commentsTab = true;
  solTab = true;
  attachTab = true;
  logTab = true;
  tabs: any;
  private slaTime: any;

  private SLA_INTERVAL_TIME = 10000;
  slaString: any;
  outerColor: any;
  innerColor: any;

  masterNameObj = [];
  page = 1;
  MAX_SIZE = 4;
  collectionSize: number;
  LIMIT = 7;
  start = 0;
  isDisabled = true;
  dynamicFields: any;
  private masterName: string;
  masterNameSelected: number;
  data = [];
  viewIncidentData = [];
  columnData = [];
  columnDefinitions1 = [];
  columnDefinitions3 = [];
  columnDefinitions4 = [];
  showGrid = false;
  columnData1 = [];
  columnData3 = [];
  columnData4 = [];
  columnDefinitions2 = [];
  showGrid1 = false;
  showGridForViewIncident = false;
  showGridForAddIncident = false;
  data2 = [];
  masterDataNameSelected: number;
  actions = [];
  statusSeq: number;
  escalatedTicket = false;
  seq: number;
  isAsset: boolean;
  addIncidentData = [];
  selectedTitles4 = [];
  private inciId: number;
  isApprovedTicket: boolean;
  isApproved: string;
  worker: any;
  searchTid: string;
  ticketCount: number;
  private addedTicket = [];
  isAddIncident: boolean;
  isViewIncident: boolean;
  private userGroupId: number;
  canAddSolution: boolean;
  canAddComment: boolean;
  typeSeq: any;
  subRadioDisplay: boolean;
  subtypes = [];
  subTypeId: any;

  private TICKET_NOT_APPROVED_OR_REJECTED = '99';
  private PROBLEM_SOLUTION_PROVIDED = 103;
  private INCIDENT_SOLUTION_PROVIDED = 2;
  private INCIDENT_TYPE_SEQ = 1;
  private PROBLEM_TYPE_SEQ = 2;

  folderLoaded = false;
  solLoaded: boolean;
  comLoaded: boolean;
  resoTime: number;
  hideAttachment: boolean;
  attachMsg: string;
  userGroups = [];
  @ViewChild('groupSelect') private groupSelect;
  private dialogRef: MatDialogRef<any, any>;
  userGroupSelected = 0;
  assetDisplayed: boolean;
  isRInfo: boolean;
  loginName: string;
  email: string;
  mobile: string;
  username: string;

  constructor(private _rest: RestApiService, private messageService: MessageService,
    private route: Router, private modalService: NgbModal, private dialog: MatDialog, notifier: NotifierService) {
    this.notifier = notifier;

  }

  onmessage(): void {
    this.worker.onmessage = (data: any) => {
      // console.log(data.data.result, typeof data.data.result);
      this.respObject = JSON.parse(data.data.result);
      // console.log(JSON.stringify(this.respObject));
      if (this.respObject.success) {
        this.percent = this.respObject.details.completedSlaPercentage;
        // console.log(typeof this.percent);
        if (Number(this.percent) >= 100) {
          this.slaString = 'YES';
          this.slaViolated = true;
          this.outerColor = '#F70E0B';
          this.innerColor = '#AF1D1B';
          // clearInterval(this.slaTime);
          this.terminateWorker();
        } else {
          this.outerColor = '#78C000';
          this.slaString = 'NO';
          this.innerColor = '#C7E596';
        }
      } else {
        alert(this.respObject.errorMessage);
      }
    };
  }

  angularGridReady(angularGrid: AngularGridInstance) {
    console.log('grid initiate');
    this.angularGrid = angularGrid;
    this.gridObj = angularGrid && angularGrid.slickGrid || {};
  }

  angularGridReady1(angularGrid: AngularGridInstance) {
    this.angularGrid1 = angularGrid;
    this.gridObj1 = angularGrid && angularGrid.slickGrid || {};
    this.columnData = this.gridObj1.getColumns();
  }

  angularGridReady2(angularGrid: AngularGridInstance) {
    this.angularGrid2 = angularGrid;
    this.gridObj2 = angularGrid && angularGrid.slickGrid || {};
    this.columnData1 = this.gridObj2.getColumns();
  }

  angularGridReady3(angularGrid: AngularGridInstance) {
    this.angularGrid3 = angularGrid;
    this.gridObj3 = angularGrid && angularGrid.slickGrid || {};
    this.columnData3 = this.gridObj3.getColumns();
  }

  angularGridReady4(angularGrid: AngularGridInstance) {
    this.angularGrid4 = angularGrid;
    this.gridObj4 = angularGrid && angularGrid.slickGrid || {};
    this.columnData4 = this.gridObj4.getColumns();
  }

  onPager(pageNumber: number): void {
    console.log('Pager event Is: ', pageNumber);
    this.start = (pageNumber * this.LIMIT) - this.LIMIT;
    this.folderClick(this.folderClicked);
    console.log('start:' + this.start);
  }

  ngOnInit() {
    this.collectionSize = 60;
    this.subRadioDisplay = false;
    this.assetDisplayed = false;
    this.isRInfo = false;
    this.fileUploadUrl = this._rest.apiRoot + '/updateFile';
    // this.percent = 0;
    this.columnDefinitions = [];
    this._rest.getUserdetails(this.messageService.getUserId()).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.clientId = this.respObject.details[0].clientId;
        // this.userGroupId = this.respObject.details[0].groupId;
        this.userGroups = this.respObject.details[0].groupId;
        // if (this.userGroups.length > 1) {
        //   this.userGroups.unshift({groupId: 0, grpName: 'Select a group'});
        //   this.userGroupSelected = 0;
        //   this.dialogRef = this.dialog.open(this.groupSelect, {
        //     width: '250px', disableClose: true
        //   });
        // } else if (this.userGroups.length === 1) {
        this.userGroupId = this.userGroups[0].groupId;
        this.userGroupSelected = this.userGroupId;
        this.onPageLoad();
        // }

      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });

    this.gridOptions = {
      enableAutoResize: true,       // true by default
      enableCellNavigation: true,
      enableFiltering: true,
      editable: true,
      rowSelectionOptions: {
        selectActiveRow: false
      },
      enableCheckboxSelector: true,
      enableRowSelection: true,

    };
    this.gridOptions1 = {
      enableAutoResize: true,       // true by default
      enableCellNavigation: true,
      enableFiltering: true,
      editable: true,
      rowSelectionOptions: {
        selectActiveRow: false
      },
      enableCheckboxSelector: true,
      enableRowSelection: true,

    };
    this.gridOptions2 = {
      enableAutoResize: true,       // true by default
      enableCellNavigation: true,
      enableFiltering: true,
      editable: true,
      rowSelectionOptions: {
        selectActiveRow: false
      },
      enableCheckboxSelector: true,
      enableRowSelection: true,

    };
    this.gridOptions3 = {
      enableAutoResize: true,       // true by default
      enableCellNavigation: true,
      enableFiltering: true,
      editable: true,
      rowSelectionOptions: {
        selectActiveRow: false
      },
      enableCheckboxSelector: true,
      enableRowSelection: true,

    };
    this.gridOptions4 = {
      enableAutoResize: true,       // true by default
      enableCellNavigation: true,
      enableFiltering: true,
      editable: true,
      rowSelectionOptions: {
        selectActiveRow: false
      },
      enableCheckboxSelector: true,
      enableRowSelection: true,

    };
    this.dataset = [];
  }

  onPageLoad() {
    this._rest.getTicketTypeForTicketCreation_LNT(this.clientId, this.userGroupId).subscribe((res1) => {
      this.respObject = res1;
      // console.log(JSON.stringify(this.respObject.details));
      this.ticketTypeLoaded = true;
      if (this.respObject.success) {
        this.typeChecked = this.respObject.details[0].id;
        this.seq = this.respObject.details[0].seq;
        // console.log('this.seq1:' + this.seq);
        if (this.seq === this.INCIDENT_TYPE_SEQ && this.respObject.details[0].asset === 'true') {
          this.assetDisplayed = true;
        } else {
          this.assetDisplayed = false;
        }
        console.log(typeof this.seq, this.seq);
        this.types = this.respObject.details;
        for (let i = 0; i < this.types.length; i++) {
          if (this.types[i].seq === this.INCIDENT_TYPE_SEQ) {
            this.inciId = this.types[i].id;
            break;
          }
        }
        this.getColumnDefintion();
        this._rest.getDynamicMenuTicketTypeWise(this.clientId, this.typeChecked,
          this.messageService.getUserId(), 1, this.userGroupId).subscribe((res2) => {
            this.respObject = res2;
            console.log(JSON.stringify(this.respObject));
            this.folderLoaded = true;
            if (this.respObject.success) {
              // this.typeChecked = this.respObject.details[0].id;
              this.menus = this.respObject.details;
            } else {
              this.notifier.notify('error', this.respObject.errorMessage);
            }
          }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
          });
      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
  }

  toggleViews() {
    this.displayed = !this.displayed;
  }

  toggleFolderViews() {
    this.folderDisplayed = !this.folderDisplayed;
  }

  changeRouting(path: string) {
    this.messageService.changeRouting(path);
  }

  getSLAPercentage() {
    this._rest.getSLA(this.tId, this.messageService.getUserId()).subscribe((res) => {
      this.respObject = res;
      console.log(JSON.stringify(this.respObject));
      if (this.respObject.success) {
        this.percent = this.respObject.details.completedSlaPercentage;
        // console.log(typeof this.percent);
        if (Number(this.percent) >= 100) {
          this.slaString = 'YES';
          this.slaViolated = true;
          this.outerColor = '#F70E0B';
          this.innerColor = '#AF1D1B';
          // clearInterval(this.slaTime);
          this.terminateWorker();
        } else {
          this.outerColor = '#78C000';
          this.slaString = 'NO';
          this.innerColor = '#C7E596';
        }
      } else {
        alert(this.respObject.errorMessage);
      }
    }, (err) => {
      alert(this.messageService.SERVER_ERROR);
    });
  }

  onButtonChange(value) {
    // console.log(value.value);
    this.typeChecked = value.value.id;
    this.seq = value.value.seq;
    this.getColumnDefintion();
    this.typeSeq = value.value.seq;
    // if (value.value.seq === 2) {
    //   this.subRadioDisplay = true;
    //   this._rest.getSubTicketType(this.clientId, this.typeChecked).subscribe((res) => {
    //     this.respObject = res;
    //     console.log(JSON.stringify(this.respObject));
    //     if (this.respObject.success) {
    //       this.subtypes = this.respObject.details;
    //       this.subTypeId=this.respObject.details[0].id;
    //     } else {
    //       this.notifier.notify('error', this.respObject.errorMessage);
    //     }
    //   }, (err) => {
    //     this.notifier.notify('error', this.messageService.SERVER_ERROR);
    //   });
    // } else {
    //   this.subRadioDisplay = false;
    // }
  }

  getColumnDefintion() {
    this._rest.getAttributesHeaderMstClientWiseWithTicket(this.clientId, this.typeChecked).subscribe((res2) => {
      this.respObject = res2;
      if (this.respObject.success) {
        const data = this.respObject.details;
        // console.log(JSON.stringify(data));
        this.columnDefinitions = [
          // {id: 'id', name: 'Id', field: 'id', minWidth: 100, sortable: true, filterable: true},
          { id: 'ticket_id', name: 'Ticket Id', field: 'ticket_id', minWidth: 100, sortable: true, filterable: true },
          {
            id: 'createdBy', name: 'Created By', field: 'createdBy', minWidth: 100, sortable: true, filterable: true
          },
          {
            id: 'createdSince', name: 'Created Since', field: 'createdSince', minWidth: 100, sortable: true, filterable: true
          },
          {
            id: 'status', name: 'Status', field: 'status', sortable: true, minWidth: 100, filterable: true
          },
          {
            id: 'reqInfo', name: 'RequesterInfo', field: 'reqInfo', minWidth: 100, sortable: true, filterable: true
          },
          {
            id: 'priority', name: 'Priority', field: 'priority', minWidth: 100, sortable: true, filterable: true
          },
          {
            id: 'assignee', name: 'Assignee', field: 'assignee', minWidth: 100, sortable: true, filterable: true
          },
          {
            id: 'LEVELSHORTDESC', name: 'Group', field: 'LEVELSHORTDESC', minWidth: 100, sortable: true, filterable: true
          },
          {
            id: 'dDate', name: 'Due Date', field: 'dDate', minWidth: 100, sortable: true, filterable: true
          },
          {
            id: 'updateDate', name: 'Last Update Date', field: 'updateDate', minWidth: 100, sortable: true, filterable: true
          },
          {
            id: 'updateBy', name: 'Last Updated By', field: 'updateBy', minWidth: 100, sortable: true, filterable: true
          },
          {
            id: 'closureDate', name: 'Closure Date', field: 'closureDate', minWidth: 100, sortable: true, filterable: true
          }
        ];
        for (let i = 0; i < data.length; i++) {
          this.columnDefinitions.push({
            id: data[i].field, name: data[i].name, field: data[i].field, minWidth: 100, sortable: true, filterable: true
          });
        }
        const classes = document.getElementsByClassName('search-filter');
        for (let i = 0; i < classes.length; i++) {
          classes[i].setAttribute('placeholder', '');
        }
      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', JSON.stringify(err));
    });
  }

  onCellClicked(e, args) {
    // console.log('this.seq:3' + this.seq);
    this.ticketCreated = false;
    this.solLoaded = true;
    this.comLoaded = true;
    this.showGrid = false;
    this.showGrid1 = false;
    this.showGridForViewIncident = false;
    this.showGridForAddIncident = false;
    this.isRInfo = false;
    const selectedRow = this.angularGrid.gridService.getColumnFromEventArguments(args);
    const data = selectedRow.dataContext;
    this.count = 0;
    console.log(JSON.stringify(data));
    this.attachment = [];
    this.ticketId = data.ticket_id;
    this.statusSeq = data.seq;
    this.priority = data.priority;
    this.gid = data.gid;
    this.gid_copy = data.gid;
    this.aid = data.aid;
    this.name = data.reqInfo;
    this.brief = data.longDesc;
    this.desc = data.tName;
    this.tId = data.id;
    this.isApproved = data.is_approved_problem_ticket;
    this.statusName = data.status;
    this.lastCatId = data.last_cat_id;
    this.lastParentId = data.last_cat_parent_id;
    this.createbyid = Number(data.createbyid);
    this.dDate = data.dDate;
    this.rDate = data.requestedDate;
    this.wfcresultId = data.ids;
    this.currentUser = data.assignee || 'Not Assigned';
    this.assignee_copy = data.assignee || 'Not Assigned';
    this.currentGroup = data.LEVELSHORTDESC;
    this.defaultStatus = false;
    this.defaultUser = false;
    this.defaultNextUser = false;
    this.cat = [];
    this.createdByMe = false;
    this.hideAttachment = true;
    // this.formData = {ticketId: this.tId, WFCClientResultId: this.wfcresultId, createdBy: this.messageService.getUserId()};
    if (Worker) {
      this.worker = new Worker('../assets/worker/worker.js');
    }
    this.onmessage();
    this.worker.postMessage({
      url: this._rest.apiRoot + '/getSlaCompletionPercentage?ticketId=' + this.tId + '&user_id=' +
        this.messageService.getUserId() + '&mapping_client_config_id=' + this.clientId,
      event: 'slaPercentage', time: this.SLA_INTERVAL_TIME, token: this.messageService.getToken()
    });
    if (data.END_INDICATOR === '0') {
      this.endIndicator = false;
    }
    // console.log(typeof data.gid, data.gid);
    // console.log(typeof this.userGroupId, this.userGroupId);
    // console.log('this.seq:4' + this.seq);
    if (!this.closedticket) {
      this.canAddSolution = true;
      this.canAddComment = true;
      if (data.createId === Number(this.messageService.getUserId())) {
        this.createdByMe = true;
      }
      if (data.aid === Number(this.messageService.getUserId())) {
        this.assignedToMe = true;
        this.isApprovedTicket = false;
        if (this.seq === this.PROBLEM_TYPE_SEQ) {
          if (this.isApproved === this.TICKET_NOT_APPROVED_OR_REJECTED) {
            this.assignedToMe = false;
            this.isApprovedTicket = true;
          }
        }
      } else {
        this.isApprovedTicket = false;
        if (this.userGroupId === data.gid) {
          this.assignedToMe = true;
        } else {
          this.assignedToMe = false;
        }
      }
    } else {
      this.assignedToMe = false;
      this.canAddSolution = false;
      this.canAddComment = false;
    }
    // console.log('this.seq:2' + this.seq);
    if (this.seq === this.PROBLEM_TYPE_SEQ) {
      this.isAsset = false;
      if (this.statusSeq === this.PROBLEM_SOLUTION_PROVIDED) {
        this.isAddIncident = false;
      } else {
        this.isAddIncident = true;
      }
      this.isViewIncident = true;
    } else {
      if (this.assetDisplayed) {
        this.isAsset = true;
      }
      this.isAddIncident = false;
      this.isViewIncident = false;
    }
    console.log('end indicator:' + this.endIndicator);
    if (this.createbyid === Number(this.messageService.getUserId())) {
      console.log(typeof this.statusSeq);
      if (this.statusSeq === this.INCIDENT_SOLUTION_PROVIDED || this.statusSeq === this.PROBLEM_SOLUTION_PROVIDED) {
        this.escalatedTicket = true;
      } else {
        this.escalatedTicket = false;
      }
      // if (this.closedticket) {
      //   this.ticketCreated = false;
      // } else {
      //   this.ticketCreated = true;
      // }
      // console.log('this.ticketCreated:' + this.ticketCreated);
    }
    this.groupDetails = undefined;
    this._rest.getNextAssigneeDtls(this.clientId, data.id, this.messageService.getUserId()).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        console.log('--->' + JSON.stringify(this.respObject));
        // this.types = this.respObject.details;
        this.assignGroupLength = this.respObject.details.length;
        if (this.respObject.details.length > 0) {
          this.groupDetails = this.respObject.details[0];
          this.supportGroupSelected = this.groupDetails.groupId;
          this.userSelected = this.groupDetails.userId;
          console.log('selected :: ' + this.supportGroupSelected, this.userSelected);
        } else {
          this.supportGroupSelected = 0;
          this.userSelected = this.aid;
        }
        console.log(this.groupDetails);
        this.getGroup();
        this.getUser(this.gid);
        // console.log(this.supportGroupSelected, this.userSelected);
      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
    this._rest.getDynamicTabActionTicketTypeWise(this.clientId, this.typeChecked,
      this.messageService.getUserId(), this.userGroupId).subscribe((res2) => {
        this.respObject = res2;
        console.log(JSON.stringify(this.respObject));
        if (this.respObject.success) {
          this.tabs = this.respObject.details.tabs;
          this.actions = this.respObject.details.actions;
          for (let i = 0; i < this.tabs.length; i++) {
            if (this.tabs[i].fid === 10) {
              this.ticketTab = false;
            } else if (this.tabs[i].fid === 11) {
              this.commentsTab = false;
            } else if (this.tabs[i].fid === 12) {
              this.solTab = false;
            } else if (this.tabs[i].fid === 13) {
              this.attachTab = false;
            } else if (this.tabs[i].fid === 14) {
              this.logTab = false;
            } else if (this.tabs[i].fid === 15) {
              if (this.assetDisplayed) {
                this.isAsset = true;
              }
            } else if (this.tabs[i].fid === 16) {
              if (this.assetDisplayed) {
                this.isAsset = true;
              }
            } else if (this.tabs[i].fid === 17) {
              if (this.seq === this.PROBLEM_TYPE_SEQ) {
                this.isViewIncident = true;
              }
            } else if (this.tabs[i].fid === 18) {
              if (this.seq === this.PROBLEM_TYPE_SEQ) {
                if (this.statusSeq === this.PROBLEM_SOLUTION_PROVIDED) {
                  this.isAddIncident = false;
                } else {
                  this.isAddIncident = true;
                }
              }
            } else if (this.tabs[i].fid === 19) {
              this.isRInfo = true;
            }
          }
          for (let i = 0; i < this.actions.length; i++) {
            console.log(this.ticketCreated);
            if (this.actions[i].fid === 9) {
              console.log('this.ticketCreated : ');
              if (this.closedticket) {
                this.ticketCreated = false;
              } else {
                this.ticketCreated = true;
              }
            }
          }
        } else {
          alert(this.respObject.errorMessage);
        }
      }, (err) => {
        alert(this.messageService.SERVER_ERROR);
      });
    this._rest.getTicketCategoryDetails(this.clientId, this.tId, this.typeChecked, 2, this.gid, this.lastCatId).subscribe((res1) => {
      this.respObject = res1;
      if (this.respObject.success) {
        console.log(JSON.stringify(this.respObject.details.cat));
        this.ticketTypes = this.respObject.details.cat;
        this.status = this.respObject.details.status;
        this.respTime = this.respObject.details.expectedTime[0].RESPONSETIME;
        this.resoTime = this.respObject.details.expectedTime[0].RESOLUTIONTIME;
        for (let i = 0; i < this.respObject.details.fields.length; i++) {
          if (this.respObject.details.fields[i].predifinedValue !== null) {
            // console.log(JSON.stringify(this.respObject.details.fields[i]))
            this.respObject.details.fields[i].values = this.respObject.details.fields[i].predifinedValue.split(',');
          }
        }
        this.dynamicFields = this.respObject.details.fields;
      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
    this.percent = 0;
    this.getSLAPercentage();
    // this.slaTime = setInterval(() => {
    //   this.getSLAPercentage();
    // }, this.SLA_INTERVAL_TIME);
    this.modalReference = this.modalService.open(this.content, { size: 'lg' });
    this.modalReference.result.then((result) => {
      // if (this.slaTime) {
      //   clearInterval(this.slaTime);
      // }
      this.terminateWorker();
    }, (reason) => {
      // if (this.slaTime) {
      //   clearInterval(this.slaTime);
      // }
      this.terminateWorker();
    });
  }

  getGroup() {
    this._rest.getSupportGroupByCategory1(this.clientId, this.lastCatId, this.gid, this.typeChecked).subscribe((res1) => {
      this.respObject = res1;
      if (this.respObject.success) {
        this.respObject.details.unshift({ id: 0, name: 'Select Group' });
        this.groups = this.respObject.details;

      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
  }

  getUser(groupId) {

    if (!this.aid) {
      this._rest.getUserByGroup(this.clientId, groupId).subscribe((res1) => {
        this.respObject = res1;
        if (this.respObject.success) {
          console.log(JSON.stringify(this.respObject));
          this.respObject.details.unshift({ id: 0, name: 'Select User' });
          this.users = this.respObject.details;
        } else {
          alert(this.respObject.errorMessage);
        }
      }, (err) => {
        alert(this.messageService.SERVER_ERROR);
      });
    } else {
      this._rest.getUserByGroup1(this.clientId, groupId, this.aid, this.messageService.getUserId()).subscribe((res1) => {
        this.respObject = res1;
        if (this.respObject.success) {
          console.log(JSON.stringify(this.respObject));
          this.respObject.details.unshift({ id: 0, name: 'Select User' });
          this.users = this.respObject.details;
        } else {
          alert(this.respObject.errorMessage);
        }
      }, (err) => {
        alert(this.messageService.SERVER_ERROR);
      });
    }
  }

  onGroupChange() {
    this.getUser(this.supportGroupSelected);
    if (this.groupDetails) {
      this.userSelected = 0;
    } else {
      this.userSelected = this.aid;
    }
    this.currentUser = 'No User Assigned';
    console.log('groupChange: ' + this.supportGroupSelected);
  }

  displayTicket(res1) {
    this.respObject = res1;
    if (this.respObject.success) {
      // console.log(JSON.stringify(this.respObject));
      // this.types = this.respObject.details;
      this.dataset = this.respObject.details;
      this.totalItems = this.dataset.length;
      // console.log('this.seq:5' + this.seq);
    } else {
      this.notifier.notify('error', this.respObject.errorMessage);
    }
  }

  folderClick(value) {
    console.log('clicked: ' + value, this.typeChecked);
    this.folderClicked = value;
    if (!this.typeChecked) {
      alert('Select Ticket Type First');
    } else {
      const params = {
        user_id: this.messageService.getUserId(),
        ticketTypeId: this.typeChecked,
        supportgrp_id: this.userGroupId,
        start: this.start,
        limit: this.LIMIT
      };
      if (value === 1) {
        // this.assignedToMe = false;
        // this.createdByMe = true;
        this.closedticket = false;
        this._rest.getTicketByMe(params).subscribe((res1) => {
          this.displayTicket(res1);
        }, (err) => {
          this.notifier.notify('error', this.respObject.SERVER_ERROR);
        });
      }
      if (value === 2) {
        // this.assignedToMe = true;
        // this.createdByMe = true;
        this.closedticket = false;
        // console.log('this.assignedToMe:' + this.assignedToMe);
        this._rest.getAssignedByMe(params).subscribe((res1) => {
          this.displayTicket(res1);
        }, (err) => {
          this.notifier.notify('error', this.respObject.SERVER_ERROR);
        });
      }
      if (value === 3) {
        // this.assignedToMe = true;
        // this.createdByMe = true;
        this.closedticket = false;
        // console.log('this.assignedToMe:' + this.assignedToMe);
        this._rest.getOpenTicketInMyGroup(params).subscribe((res1) => {
          this.displayTicket(res1);
        }, (err) => {
          this.notifier.notify('error', this.respObject.SERVER_ERROR);
        });
      }
      if (value === 4) {
        // this.assignedToMe = false;
        this.closedticket = true;
        this._rest.getMyCloseTicket(params).subscribe((res1) => {
          this.displayTicket(res1);
        }, (err) => {
          this.notifier.notify('error', this.respObject.SERVER_ERROR);
        });
      }
      if (value === 5) {
        // this.assignedToMe = false;
        this.closedticket = true;
        this._rest.getCloseTicketInMyGroup(params).subscribe((res1) => {
          this.displayTicket(res1);
        }, (err) => {
          this.notifier.notify('error', this.respObject.SERVER_ERROR);
        });
      }
      if (value === 6) {
        // this.assignedToMe = false;
        this.closedticket = false;
        this._rest.getMyForwardedTickets(params).subscribe((res1) => {
          this.displayTicket(res1);
        }, (err) => {
          this.notifier.notify('error', this.respObject.SERVER_ERROR);
        });
      }
      if (value === 7) {
        // this.assignedToMe = false;
        this.closedticket = false;
        this._rest.getMyForwardedTicketsInGroup(params).subscribe((res1) => {
          this.displayTicket(res1);
        }, (err) => {
          this.notifier.notify('error', this.respObject.SERVER_ERROR);
        });
      }
    }
  }

  onCellChanged(e, args) {
    console.log(args.item);
  }

  handleSelectedRowsChanged(e, args) {
    if (Array.isArray(args.rows)) {
      this.selectedTitles = args.rows.map(idx => {
        const item = this.gridObj.getDataItem(idx);
        return item || '';
      });
      if (this.selectedTitles.length > 0) {
        this.show = true;
        this.selected = this.selectedTitles.length;
      } else {
        this.show = false;
      }
      console.log(JSON.stringify(this.selectedTitles));
    }
  }

  handleSelectedRowsChanged1(e, args) {
    if (Array.isArray(args.rows)) {
      this.selectedTitles = args.rows.map(idx => {
        const item = this.gridObj1.getDataItem(idx);
        return item || '';
      });
    }
  }

  handleSelectedRowsChanged2(e, args) {
    if (Array.isArray(args.rows)) {
      this.selectedTitles2 = args.rows.map(idx => {
        const item = this.gridObj2.getDataItem(idx);
        return item || '';
      });

    }
  }

  onTicketChange(ticket, option) {
    const opt = JSON.parse(option);
    // console.log(JSON.stringify(ticket));
    if (opt.type !== 'header') {
      const value = opt.id;
      let matched = false;
      const index = this.ticketTypes.map(function (d) {
        return d['id'];
      }).indexOf(ticket.id + 1);
      const index1 = this.ticketTypes.map(function (d) {
        return d['id'];
      }).indexOf(ticket.id);
      console.log(index1);
      let pid;
      if (index1 > 0) {
        pid = this.ticketTypes[index1].options[0].id;
      } else {
        pid = this.ticketTypes[index1].options[1].id;
      }
      console.log(this.ticketTypes[index1].options[0]);
      if (this.cat.length === 0) {
        this.cat.push({ pid: pid, cid: value });
      } else {
        for (let i = 0; i < this.cat.length; i++) {
          if (this.cat[i].pid === pid) {
            matched = true;
            this.cat[i].cid = value;
            break;
          }
        }
        if (!matched) {
          this.cat.push({ pid: pid, cid: value });
        } else {
          for (let i = index; i < this.cat.length; i++) {
            this.cat[i].cid = 0;
          }
        }
      }
      // console.log('---->' + JSON.stringify(this.cat));
      console.log(value);
      let data;
      for (let i = 0; i < this.ticketTypes[index].options.length; i++) {
        if (this.ticketTypes[index].options[i].type) {
          data = this.ticketTypes[index].options[i];
        }
      }
      for (let i = index + 1; i < this.ticketTypes.length; i++) {
        const options = this.ticketTypes[i].options;
        for (let j = 0; j < options.length; j++) {
          if (options[j].type) {
            // options=[];
            this.ticketTypes[i].options = [options[j]];
            break;
          }
        }
      }
      // console.log(JSON.stringify(this.ticketTypes), ticket.id);
      if (ticket.id === 1) {
        if (value === Number(this.lastCatId)) {
          this._rest.getAddionalFieldWithValue(this.tId).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
              // console.log(JSON.stringify(this.respObject.details));
              for (let i = 0; i < this.respObject.details.length; i++) {
                if (this.respObject.details[i].predifinedValue !== null) {
                  this.respObject.details[i].values = this.respObject.details[i].predifinedValue.split(',');
                }
              }
              this.dynamicFields = this.respObject.details;
            } else {
              // this.notifier.notify('error', this.respObject.errorMessage);
            }
          }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
          });
        } else {
          this._rest.getTicketFieldsCatWise({ clientId: this.clientId, catId: value, ticketTypeId: this.typeChecked }).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
              console.log(JSON.stringify(this.respObject.details));
              for (let i = 0; i < this.respObject.details.length; i++) {
                if (this.respObject.details[i].predifinedValue !== null) {
                  this.respObject.details[i].values = this.respObject.details[i].predifinedValue.split(',');
                  this.respObject.details[i].value = this.respObject.details[i].values[0];
                } else {
                  this.respObject.details[i].value = '';
                }
              }
              this.dynamicFields = this.respObject.details;
            } else {
              // this.notifier.notify('error', this.respObject.errorMessage);
            }
          }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
          });
        }

      }
      this._rest.getAttributesParentWise(this.clientId, value).subscribe((res) => {
        this.respObject = res;

        if (this.respObject.success) {
          this.respObject.details.unshift(data);
          // console.log(JSON.stringify(this.respObject.details));
          this.ticketTypes[index].options = this.respObject.details;
        } else {
          // this.notifier.notify('error', this.respObject.errorMessage);
          if (this.respObject.errorMessage === 'No data found') {
            this.ticketTypes[index].options = [data];
          }
        }
      }, (err) => {
        this.notifier.notify('error', this.messageService.SERVER_ERROR);
      });
    }
  }

  statusClick() {
    this.defaultStatus = !this.defaultStatus;
  }

  userClick(type) {
    this.defaultUser = !this.defaultUser;
    if (this.groupDetails) {
      if (type === 'close') {
        if (this.supportGroupSelected === this.groupDetails.groupId) {
          this.userSelected = this.groupDetails.userId;
        } else {
          this.userSelected = 0;
        }
      } else {
        this.userSelected = 0;
      }
    } else {
      this.userSelected = this.aid;
      // this.supportGroupSelected = 0;
    }
    console.log('userCancel: ' + this.userSelected);
  }

  nextUserClick(type) {
    this.defaultNextUser = !this.defaultNextUser;
    if (this.groupDetails) {
      this.supportGroupSelected = this.groupDetails.groupId;
      this.gid_copy = this.groupDetails.groupId;
      if (type === 'close') {
        // console.log('close' + this.groupDetails.userId);
        this.userSelected = this.groupDetails.userId;
        this.currentUser = this.assignee_copy;
        this.gid_copy = this.gid;
      } else {
        this.userSelected = 0;
        this.currentUser = 'No User Assigned';
      }
    } else {
      this.supportGroupSelected = 0;
      this.userSelected = this.aid;
    }

    console.log('groupCancel: ' + this.supportGroupSelected);
    this.getUser(this.supportGroupSelected);
  }

  updateTicket() {
    let cats = '';
    let extrafields = '';
    let isError = false;
    if (this.cat.length === this.ticketTypes.length) {
      for (let i = 0; i < this.cat.length; i++) {
        if (this.cat[i].cid !== 0) {
          cats += this.cat[i].pid + '#' + this.cat[i].cid;
          if (i !== this.cat.length - 1) {
            cats += ',';
          }
        } else {
          isError = true;
          break;
        }
      }
    } else {
      isError = true;
    }
    console.log(cats);
    // if (isError) {
    //   this.notifier.notify('error', this.messageService.CATEGORY_ERROR);
    // } else {
    for (let i = 0; i < this.dynamicFields.length; i++) {
      if (this.dynamicFields[i].value !== '') {
        if (i === this.dynamicFields.length - 1) {
          extrafields += this.dynamicFields[i].id + '@' + this.dynamicFields[i].value;
        } else {
          extrafields += this.dynamicFields[i].id + '@' + this.dynamicFields[i].value + '#';
        }
      }
    }
    extrafields = extrafields.substring(extrafields.length - 1, extrafields.length) === '#'
      ? extrafields.substring(0, extrafields.length - 1) : extrafields;
    const data = {
      'id': this.tId,
      'requesterInfo': this.name,
      'tName': this.desc,
      'longDesc': this.brief,
      'attachedFilePath': this.attachment,
      'requestedDate': this.rDate,
      'dueDate': this.dDate,
      'WFCClientResultId': this.wfcresultId,
      'createdBy': this.messageService.getUserId(),
      'clientId': this.clientId,
      'categoryDtlsLt': cats
    };
    if (extrafields !== '') {
      data['fieldValueDtls'] = extrafields;
    }
    console.log(JSON.stringify(data));
    this._rest.updateTicket(data).subscribe((res1) => {
      this.respObject = res1;
      console.log(JSON.stringify(this.respObject));
      if (this.respObject.success) {
        this.attachment = [];
        this.hideAttachment = true;
        alert('Ticket Updated Successfully');
      } else {
        alert(this.respObject.errorMessage);
      }
    }, (err) => {
      alert(this.messageService.SERVER_ERROR);
    });
  }

  addComment() {
    if (this.aid === undefined) {
      alert(this.messageService.BLANK_USER);
    } else {
      if (this.comment && this.comment !== '') {
        const data = {
          ticketId: this.tId,
          WFCClientResultId: this.wfcresultId,
          createdBy: this.messageService.getUserId(),
          feedback: this.comment,
          clientId: this.clientId,
          cat_id: this.lastCatId
        };
        // console.log(JSON.stringify(data));
        this.comLoaded = false;
        this.canAddComment = false;
        this._rest.submitFeedbackTicketWise(data).subscribe((res1) => {
          this.respObject = res1;
          this.comLoaded = true;
          this.canAddComment = true;
          if (this.respObject.success) {
            this.comment = '';
            this.getComments();
          } else {
            alert(this.respObject.errorMessage);
          }
        }, (err) => {
          // this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
      } else {
        alert(this.messageService.BLANK_COMMENT);
      }
    }
  }

  addSolution() {
    if (this.aid === undefined) {
      alert(this.messageService.BLANK_USER);
    } else {
      if (this.solution && this.solution !== '') {
        const data = {
          ticketId: this.tId,
          WFCClientResultId: this.wfcresultId,
          createdBy: this.messageService.getUserId(),
          solutions: this.solution,
          clientId: this.clientId,
          rca: '',
          ticket_type_seq: this.seq
        };
        this.solLoaded = false;
        this.canAddSolution = false;
        this._rest.submitSolutionsTicketWise(data).subscribe((res1) => {
          this.respObject = res1;
          this.solLoaded = true;
          this.canAddSolution = true;
          if (this.respObject.success) {
            this.solution = '';
            this.folderClick(this.folderClicked);
            alert('Solution Provided successfully');
            // if (this.slaTime) {
            //   clearInterval(this.slaTime);
            // }
            this.terminateWorker();
            this.modalReference.close();
            // this.getSolutions();
          } else {
            alert(this.respObject.errorMessage);
          }
        }, (err) => {
          // this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
      } else {
        alert(this.messageService.BLANK_SOLUTION);
      }
    }
  }

  forwardTicket() {
    if (this.statusSeq === 105) {
      const data = {
        clientId: this.clientId,
        id: this.tId,
        createdBy: this.messageService.getUserId(),
        cat_id: this.lastCatId,
        parent_cat_id: this.lastParentId,
        ticketTypeId: this.typeChecked
      };
      this._rest.forwardProblemTicketAfterChangesToApprover(data).subscribe((res1) => {
        this.respObject = res1;
        console.log(JSON.stringify(this.respObject));
        if (this.respObject.success) {
          this.folderClick(this.folderClicked);
          alert('Ticket Forwarded successfully');
          // if (this.slaTime) {
          //   clearInterval(this.slaTime);
          // }
          this.terminateWorker();
          this.modalReference.close();
        } else {
          alert(this.respObject.errorMessage);
        }
      }, (err) => {
        alert(this.messageService.SERVER_ERROR);
      });
    } else {
      console.log('inside forward:' + this.supportGroupSelected, this.userSelected);
      console.log('gid:' + this.gid, this.gid_copy);
      console.log('aid:' + this.aid);
      let type = '', isDeviation = false, userChange = false;
      console.log(this.groupDetails);
      if (this.groupDetails) {
        console.log('first if');
        if (this.userSelected !== this.groupDetails.userId) {
          console.log('first if if');
          if (this.gid_copy === this.gid) {
            console.log('first if if1 if');
            type = 'Own';
            this.supportGroupSelected = this.gid;
          }
        }
        if (Number(this.supportGroupSelected) !== this.groupDetails.groupId && type !== 'Own') {
          console.log('first if if2 if');
          isDeviation = true;
        }
      } else {
        console.log('first else');
        if (this.userSelected !== this.aid && this.userSelected !== 0) {
          console.log('first else if');
          userChange = true;
          if (this.supportGroupSelected === 0) {
            type = 'Own';
            this.supportGroupSelected = this.gid;
          }
        }
        if (type !== 'Own') {
          isDeviation = true;
        }
      }
      if (this.aid === undefined && type !== 'Own') {
        alert(this.messageService.BLANK_USER);
      } else {
        console.log(isDeviation, this.supportGroupSelected);
        if (this.assignedToMe) {

          const data = {
            id: this.tId,
            supportGroupLevelId: this.supportGroupSelected,
            createdBy: this.messageService.getUserId(),
            user_id: this.userSelected,
            cat_id: this.lastCatId,
            parent_cat_id: this.lastParentId,
            frdType: type,
            isDeviation: isDeviation,
            WFCClientResultId: this.wfcresultId
          };
          let solProvided = false;
          if (this.statusSeq === this.INCIDENT_SOLUTION_PROVIDED || this.statusSeq === this.PROBLEM_SOLUTION_PROVIDED) {
            solProvided = true;
          }
          // data['selected'] = (this.assignGroupLength === 0 && solProvided && !isDeviation && !userChange) ? 0 : 1;
          console.log(JSON.stringify(data));
          if (this.supportGroupSelected > 0) {
            data['selected'] = 1;
            this._rest.updateForwardedTicket(data).subscribe((res1) => {
              this.respObject = res1;
              console.log(JSON.stringify(this.respObject));
              if (this.respObject.success) {
                this.folderClick(this.folderClicked);
                alert('Ticket Forwarded successfully');
                // if (this.slaTime) {
                //   clearInterval(this.slaTime);
                // }
                this.terminateWorker();
                this.modalReference.close();
              } else {
                alert(this.respObject.errorMessage);
              }
            }, (err) => {
              alert(this.messageService.SERVER_ERROR);
            });
          } else {
            if (solProvided) {
              data['selected'] = 0;
              data['user_id'] = 0;
              this._rest.updateForwardedTicket(data).subscribe((res1) => {
                this.respObject = res1;
                console.log(JSON.stringify(this.respObject));
                if (this.respObject.success) {
                  this.folderClick(this.folderClicked);
                  alert('Ticket Forwarded successfully');
                  // if (this.slaTime) {
                  //   clearInterval(this.slaTime);
                  // }
                  this.terminateWorker();
                  this.modalReference.close();
                } else {
                  alert(this.respObject.errorMessage);
                }
              }, (err) => {
                alert(this.messageService.SERVER_ERROR);
              });
            } else {
              alert('Workflow End. Please select support group if you want to forward the ticket');
            }
          }
          // }
        }
      }
    }
  }

  setStatus() {
    const data = {
      id: this.wfcresultId,
      tStatus: this.statusSelected,
      user_id: this.messageService.getUserId(),
      ticketId: this.tId,
      clientId: this.clientId
    };
    this._rest.updateTicketStatus(data).subscribe((res1) => {
      this.respObject = res1;
      console.log(JSON.stringify(this.respObject));
      if (this.respObject.success) {
        alert('Status Changed Successfully');
        this.statusName = this.status[this.statusIndex].name;
        this.statusClick();
      } else {
        alert(this.respObject.errorMessage);
      }
    }, (err) => {
      alert(this.messageService.SERVER_ERROR);
    });
  }

  onStatusChange(selectedIndex: any) {
    this.statusIndex = selectedIndex;
  }

  saveAssetData() {
    const ids = [];
    for (let i = 0; i < this.selectedTitles2.length; i++) {
      ids.push(this.selectedTitles2[i].id);
    }
    this._rest.insertAssetIds({
      ticketId: this.tId,
      WFCClientResultId: this.wfcresultId,
      assetIds: ids,
      createdBy: this.messageService.getUserId()
    }).subscribe((res1) => {
      this.respObject = res1;
      // console.log(JSON.stringify(this.respObject));
      if (this.respObject.success) {
        alert('Data Successfully saved');
      } else {
        alert(this.respObject.errorMessage);
      }
    }, (err) => {
      alert(this.messageService.SERVER_ERROR);
    });
  }

  tabClick(event) {
    // console.log(event.tab.textLabel);
    if (event.tab.textLabel === 'Comments') {
      this.getComments();
    } else if (event.tab.textLabel === 'Activity Logs') {
      this._rest.getLogsTicketWise(this.tId).subscribe((res1) => {
        this.respObject = res1;
        // console.log(JSON.stringify(this.respObject));
        if (this.respObject.success) {
          this.logs = this.respObject.details;
        } else {
          // this.notifier.notify('error', this.respObject.errorMessage);
          alert(this.respObject.errorMessage);
        }
      }, (err) => {
        // this.notifier.notify('error', this.messageService.SERVER_ERROR);
      });
    } else if (event.tab.textLabel === 'Solutions') {
      this.getSolutions();
    } else if (event.tab.textLabel === 'Attachments') {
      this._rest.getAttachmentTicketWise(this.tId).subscribe((res1) => {
        this.respObject = res1;
        // console.log(JSON.stringify(this.respObject));
        if (this.respObject.success) {
          for (let i = 0; i < this.respObject.details.length; i++) {
            this.respObject.details[i].attacheMent = this.messageService.UPLOAD_PATH + this.respObject.details[i].attachedFilePath;
          }
          this.attachments = this.respObject.details;
        } else {
          // this.notifier.notify('error', this.respObject.errorMessage);
          alert(this.respObject.errorMessage);
        }
      }, (err) => {
        // this.notifier.notify('error', this.messageService.SERVER_ERROR);
      });

    } else if (event.tab.textLabel === 'View Asset Details') {
      this.columnDefinitions1 = [{
        id: 'delete',
        field: 'id',
        excludeFromHeaderMenu: true,
        formatter: Formatters.deleteIcon,
        minWidth: 30,
        maxWidth: 30,
      }];
      this.showGrid = true;
      this._rest.getAssetMasterByTicket(this.tId).subscribe((res1) => {
        this.respObject = res1;
        if (this.respObject.success) {
          const dataArr = this.respObject.details;
          this.masterNameObj = dataArr;
          this.masterNameObj.unshift({ id: 0, masterName: 'Select asset master name' });
          this.totalData = dataArr.length;
          this.masterNameSelected = 0;
          if (this.gridObj1) {
            this.gridObj1.invalidateAllRows();
          }
        } else {
          this.notifier.notify('error', this.respObject.errorMessage);
        }
      }, (err) => {
        this.notifier.notify('error', this.messageService.SERVER_ERROR);
      });
    } else if (event.tab.textLabel === 'Add Asset Details') {
      this.columnDefinitions2 = [{
        id: 'delete',
        field: 'id',
        excludeFromHeaderMenu: true,
        formatter: Formatters.deleteIcon,
        minWidth: 30,
        maxWidth: 30,
      }];
      this.showGrid1 = true;
      this._rest.getAssetManagementMaster(this.clientId).subscribe((res1) => {
        this.respObject = res1;
        if (this.respObject.success) {
          const dataArr = this.respObject.details;
          // console.log('master data=', dataArr);
          this.masterNameObj = dataArr;
          this.masterNameObj.unshift({ id: 0, masterName: 'Select asset master name' });
          this.totalData = dataArr.length;
          this.masterDataNameSelected = 0;
          if (this.gridObj2) {
            this.gridObj2.invalidateAllRows();
          }
        } else {
          this.notifier.notify('error', this.respObject.errorMessage);
        }
      }, (err) => {
        this.notifier.notify('error', this.messageService.SERVER_ERROR);
      });
    } else if (event.tab.textLabel === 'View Incident') {
      // console.log('view incident');
      this.columnDefinitions3 = [{
        id: 'delete',
        field: 'id',
        excludeFromHeaderMenu: true,
        formatter: Formatters.deleteIcon,
        minWidth: 30,
        maxWidth: 30,
      }];
      this.showGridForViewIncident = true;
      this._rest.getMappedIncidentTicketDetails(this.clientId, this.inciId, this.tId).subscribe((res2) => {
        this.respObject = res2;
        if (this.respObject.success) {
          const data = this.respObject.details[0];
          const data1 = [];

          // console.log(JSON.stringify(data));
          const columnDef = [
            { id: 'id', name: 'Id', field: 'id', minWidth: 100, sortable: true, filterable: true },
            { id: 'ticket_id', name: 'Ticket Id', field: 'ticket_id', minWidth: 100, sortable: true, filterable: true },
            {
              id: 'createdBy', name: 'Created By', field: 'createdBy', minWidth: 100, sortable: true, filterable: true
            },
            {
              id: 'createdSince', name: 'Created Since', field: 'createdSince', minWidth: 100, sortable: true, filterable: true
            },
            {
              id: 'status', name: 'Status', field: 'status', sortable: true, minWidth: 100, filterable: true
            },
            {
              id: 'reqInfo', name: 'RequesterInfo', field: 'reqInfo', minWidth: 100, sortable: true, filterable: true
            },
            {
              id: 'priority', name: 'Priority', field: 'priority', minWidth: 100, sortable: true, filterable: true
            },
            {
              id: 'assignee', name: 'Assignee', field: 'assignee', minWidth: 100, sortable: true, filterable: true
            },
            {
              id: 'LEVELSHORTDESC', name: 'Group', field: 'LEVELSHORTDESC', minWidth: 100, sortable: true, filterable: true
            },
            {
              id: 'dDate', name: 'Due Date', field: 'dDate', minWidth: 100, sortable: true, filterable: true
            },
            {
              id: 'updateDate', name: 'Last Update Date', field: 'updateDate', minWidth: 100, sortable: true, filterable: true
            },
            {
              id: 'updateBy', name: 'Last Updated By', field: 'updateBy', minWidth: 100, sortable: true, filterable: true
            },
            {
              id: 'closureDate', name: 'Closure Date', field: 'closureDate', minWidth: 100, sortable: true, filterable: true
            }
          ];
          for (let i = 0; i < this.columnData3.length; i++) {
            data1.push(this.columnData3[i]);
          }
          for (let i = 0; i < columnDef.length; i++) {
            data1.push(columnDef[i]);
          }
          for (let i = 0; i < data.length; i++) {
            data1.push({
              id: data[i].field, name: data[i].name, field: data[i].field, minWidth: 100, sortable: true, filterable: true
            });
          }
          this.gridObj3.setColumns(data1);
          this.viewIncidentData = this.respObject.details[1];
          // const classes = document.getElementsByClassName('search-filter');
          // for (let i = 0; i < classes.length; i++) {
          //   classes[i].setAttribute('placeholder', '');
          // }
        } else {
          alert(this.respObject.errorMessage);
        }
      }, (err) => {
        alert(this.messageService.SERVER_ERROR);
      });
    } else if (event.tab.textLabel === 'Add Incident') {
      this.ticketCount = 0;
      this.addedTicket = [];
      this.showGridForAddIncident = true;
      this._rest.getAttributesHeaderMstClientWiseWithTicket(this.clientId, this.inciId).subscribe((res2) => {
        this.respObject = res2;
        if (this.respObject.success) {
          const data = this.respObject.details;
          const data1 = [];

          // console.log(JSON.stringify(data));
          const columnDef = [
            { id: 'id', name: 'Id', field: 'id', minWidth: 100, sortable: true, filterable: true },
            { id: 'ticket_id', name: 'Ticket Id', field: 'ticket_id', minWidth: 100, sortable: true, filterable: true },
            {
              id: 'createdBy', name: 'Created By', field: 'createdBy', minWidth: 100, sortable: true, filterable: true
            },
            {
              id: 'createdSince', name: 'Created Since', field: 'createdSince', minWidth: 100, sortable: true, filterable: true
            },
            {
              id: 'status', name: 'Status', field: 'status', sortable: true, minWidth: 100, filterable: true
            },
            {
              id: 'reqInfo', name: 'RequesterInfo', field: 'reqInfo', minWidth: 100, sortable: true, filterable: true
            },
            {
              id: 'priority', name: 'Priority', field: 'priority', minWidth: 100, sortable: true, filterable: true
            },
            {
              id: 'assignee', name: 'Assignee', field: 'assignee', minWidth: 100, sortable: true, filterable: true
            },
            {
              id: 'LEVELSHORTDESC', name: 'Group', field: 'LEVELSHORTDESC', minWidth: 100, sortable: true, filterable: true
            },
            {
              id: 'dDate', name: 'Due Date', field: 'dDate', minWidth: 100, sortable: true, filterable: true
            },
            {
              id: 'updateDate', name: 'Last Update Date', field: 'updateDate', minWidth: 100, sortable: true, filterable: true
            },
            {
              id: 'updateBy', name: 'Last Updated By', field: 'updateBy', minWidth: 100, sortable: true, filterable: true
            },
            {
              id: 'closureDate', name: 'Closure Date', field: 'closureDate', minWidth: 100, sortable: true, filterable: true
            }
          ];
          for (let i = 0; i < this.columnData4.length; i++) {
            data1.push(this.columnData4[i]);
          }
          for (let i = 0; i < columnDef.length; i++) {
            data1.push(columnDef[i]);
          }
          for (let i = 0; i < data.length; i++) {
            data1.push({
              id: data[i].field, name: data[i].name, field: data[i].field, minWidth: 100, sortable: true, filterable: true
            });
          }
          this.gridObj4.setColumns(data1);

          this.addIncidentData = [];
          this.gridObj4.getSelectionModel().setSelectedRanges([]);
        } else {
          alert(this.respObject.errorMessage);
        }
      }, (err) => {
        alert(this.messageService.SERVER_ERROR);
      });
    } else if (event.tab.textLabel === 'Requestor Info') {
      this._rest.getUserdetails(this.createbyid).subscribe((res1) => {
        this.respObject = res1;
        // console.log(JSON.stringify(this.respObject));
        this.dialog.closeAll();
        if (this.respObject.success) {
          const userInfo = this.respObject.details[0];
          this.loginName = userInfo.login_name;
          this.username = userInfo.name;
          this.email = this.messageService.xorEncode(atob(userInfo.email), this.messageService.SECRET_TOKEN);
          this.mobile = this.messageService.xorEncode(atob(userInfo.mobile), this.messageService.SECRET_TOKEN);
        } else {
          this.notifier.notify('error', this.respObject.errorMessage);
        }
      }, (err) => {
        this.notifier.notify('error', this.messageService.SERVER_ERROR);
      });
    }
  }

  onMasterChange(value: any) {
    this.masterName = this.masterNameObj[value].masterName;
    // =================================== get column and column value details================================
    this._rest.getTicketWiseAssetData(this.tId, this.masterNameSelected).subscribe((res) => {
      this.respObject = res;
      // console.log(this.respObject)
      if (this.respObject.success) {
        this.gridObj1.getSelectionModel().setSelectedRanges([]);
        this.data = [];
        const data1 = [];
        for (let i = 0; i < this.columnData.length; i++) {
          data1.push(this.columnData[i]);
        }
        const data = this.respObject.details;
        const columnNameObj = data.columnObj;
        const columnValueObj = data.valueObj;
        data1.push({ id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true });
        for (let i = 0; i < columnNameObj.length; i++) {
          data1.push({
            id: columnNameObj[i].columnName,
            name: columnNameObj[i].columnName,
            field: columnNameObj[i].id,
            sortable: true,
            filterable: true
          });

        }
        this.gridObj1.setColumns(data1);
        const colval = [];
        for (let j = 0; j < columnValueObj.length; j++) {
          const columVal = columnValueObj[j].columVal;
          const descId = columnValueObj[j].id;
          const columnValue = columVal.split(',');
          // console.log('column=', JSON.stringify(columnValue));
          const jsonval = {};
          jsonval['id'] = descId;
          for (let k = 0; k < columnValue.length; k++) {
            const attrVal = columnValue[k];
            const attrValue = attrVal.split(':');

            jsonval[attrValue[0]] = attrValue[1];
          }
          colval.push(jsonval);
        }
        this.data = colval;


      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
    // =============================================================================================================
  }

  terminateWorker() {
    this.worker.terminate();
  }

  getComments() {
    this._rest.getCommentsByTicketId(this.tId).subscribe((res1) => {
      this.respObject = res1;
      console.log(JSON.stringify(this.respObject));
      if (this.respObject.success) {
        this.comments = this.respObject.details;
      } else {
        alert(this.respObject.errorMessage);
      }
    }, (err) => {
      alert(this.messageService.SERVER_ERROR);
    });
  }

  closeTicket() {
    if (this.ticketCreated) {
      const modalRef = this.modalService.open(CSATmodalComponent, {
        size: 'lg', windowClass: 'large-modal'
      });
      modalRef.componentInstance.id = this.wfcresultId;
      modalRef.componentInstance.user_id = this.messageService.getUserId();
      modalRef.componentInstance.ticketId = this.tId;
      modalRef.componentInstance.seq = this.seq;
      modalRef.componentInstance.type = 'csat';
      modalRef.componentInstance.header = 'CSAT Form';
    }
  }

  getSolutions() {
    this._rest.getSolutionsTicketWise(this.tId).subscribe((res1) => {
      this.respObject = res1;
      // console.log(JSON.stringify(this.respObject));
      if (this.respObject.success) {
        this.solutions = this.respObject.details;
      } else {
        // this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      // this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
  }

  onFileComplete(data: any) {
    console.log(data);
    if (data.success) {
      this.hideAttachment = false;
      this.attachment.push({ originalName: data.fileName, fileName: data.changedName });
      if (this.attachment.length > 1) {
        this.attachMsg = this.attachment.length + ' files';
      } else {
        this.attachMsg = this.attachment.length + ' file';
      }
    }
  }

  onCellClicked1(e, args) {
    const metadata = this.angularGrid1.gridService.getColumnFromEventArguments(args);
    // console.log(metadata);

    if (metadata.columnDef.id === 'delete') {
      console.log(JSON.stringify(metadata.dataContext));
      if (confirm('Are you sure?')) {
        this._rest.deleteTicketAssetData({
          id: metadata.dataContext.id,
          ticketId: this.tId,
          WFCCResult_id: this.wfcresultId,
          user_id: this.messageService.getUserId()
        }).subscribe((res) => {
          this.respObject = res;
          if (this.respObject.success) {
            this.angularGrid1.gridService.deleteDataGridItemById(metadata.dataContext.id);
          } else {
            alert(this.messageService.SERVER_ERROR);
          }
        }, (err) => {
          alert(this.messageService.SERVER_ERROR);
        });
      }
    }
  }

  onMasterDataChange(selectedIndex: any) {
    this._rest.getAssetManagementData(this.clientId, this.masterDataNameSelected).subscribe((res) => {
      this.respObject = res;
      // console.log(this.respObject)
      if (this.respObject.success) {
        this.gridObj2.getSelectionModel().setSelectedRanges([]);
        this.data2 = [];
        const data1 = [];
        for (let i = 0; i < this.columnData1.length; i++) {
          data1.push(this.columnData1[i]);
        }
        const data = this.respObject.details;
        const columnNameObj = data.columnObj;
        const columnValueObj = data.valueObj;
        data1.push({ id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true });
        for (let i = 0; i < columnNameObj.length; i++) {
          data1.push({
            id: columnNameObj[i].columnName,
            name: columnNameObj[i].columnName,
            field: columnNameObj[i].id,
            sortable: true,
            filterable: true
          });

        }
        this.gridObj2.setColumns(data1);
        const colval = [];
        for (let j = 0; j < columnValueObj.length; j++) {
          const columVal = columnValueObj[j].columVal;
          const descId = columnValueObj[j].id;
          const columnValue = columVal.split(',');
          // console.log('column=', JSON.stringify(columnValue));
          const jsonval = {};
          jsonval['id'] = descId;
          for (let k = 0; k < columnValue.length; k++) {
            const attrVal = columnValue[k];
            const attrValue = attrVal.split(':');

            jsonval[attrValue[0]] = attrValue[1];
          }
          colval.push(jsonval);
        }
        this.data2 = colval;


      } else {
        this.notifier.notify('error', this.respObject.errorMessage);
      }
    }, (err) => {
      this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
  }

  escalateTicket() {
    const data = {
      id: this.tId,
      WFCClientResultId: this.wfcresultId,
      createdBy: this.messageService.getUserId(),
      clientId: this.clientId
    };
    this._rest.escalationByCreatorAfterResolve(data).subscribe((res1) => {
      this.respObject = res1;
      // console.log(JSON.stringify(this.respObject));
      if (this.respObject.success) {
        this.folderClick(this.folderClicked);
        alert('Escalated successfully');
        // if (this.slaTime) {
        //   clearInterval(this.slaTime);
        // }
        this.terminateWorker();
        this.modalReference.close();
        // this.getSolutions();
      } else {
        alert(this.respObject.errorMessage);
      }
    }, (err) => {
      alert(this.messageService.SERVER_ERROR);
    });
  }

  approveTicket() {
    if (this.groupDetails) {
      const modalRef = this.modalService.open(CSATmodalComponent, {
        size: 'lg', windowClass: 'large-modal'
      });

      modalRef.componentInstance.id = this.wfcresultId;
      modalRef.componentInstance.user_id = this.messageService.getUserId();
      modalRef.componentInstance.ticketId = this.tId;
      modalRef.componentInstance.cat_id = this.lastCatId;
      modalRef.componentInstance.parent_cat_id = this.lastParentId;
      modalRef.componentInstance.groupId = this.groupDetails.groupId;
      modalRef.componentInstance.selectedUserID = this.groupDetails.userId;
      modalRef.componentInstance.ticket_type_seq = this.seq;
      modalRef.componentInstance.type = 'approve';
      modalRef.componentInstance.header = 'Approval Form';
    } else {
      alert('You don\'t have any next group to be forwarded');
    }
  }

  handleSelectedRowsChanged4(eventData: any, args: any) {
    if (Array.isArray(args.rows)) {
      this.selectedTitles4 = args.rows.map(idx => {
        const item = this.gridObj4.getDataItem(idx);
        return item || '';
      });
    }
  }

  saveIncidentData() {
    let incIds = '';
    for (let i = 0; i < this.addedTicket.length; i++) {
      if (i === this.addedTicket.length - 1) {
        incIds += this.addedTicket[i].id;
      } else {
        incIds += this.addedTicket[i].id + ',';
      }
    }
    const data = {
      ticketId: this.tId,
      incident_ticket_list: incIds,
      createdBy: this.messageService.getUserId(),
      client_id: this.clientId
    };
    this._rest.addNewIncidentInProblem(data).subscribe((res1) => {
      this.respObject = res1;
      // console.log(JSON.stringify(this.respObject));
      if (this.respObject.success) {
        alert('Ticket Added successfully');
        // this.getSolutions();
      } else {
        alert(this.respObject.errorMessage);
      }
    }, (err) => {
      alert(this.messageService.SERVER_ERROR);
    });
  }

  onCellClicked3(eventData: any, args: any) {
    const metadata = this.angularGrid3.gridService.getColumnFromEventArguments(args);
    // console.log(metadata);

    if (metadata.columnDef.id === 'delete') {
      console.log(JSON.stringify(metadata.dataContext));
      if (confirm('Are you sure?')) {
        // const incIds = [];
        // incIds.push(metadata.dataContext.id+"");
        this._rest.deleteNewIncidentInProblem({
          incident_ticket_list: metadata.dataContext.id + '',
          id: this.tId,
          user_id: this.messageService.getUserId()
        }).subscribe((res) => {
          this.respObject = res;
          if (this.respObject.success) {
            this.angularGrid3.gridService.deleteDataGridItemById(metadata.dataContext.id);
          } else {
            alert(this.messageService.SERVER_ERROR);
          }
        }, (err) => {
          alert(this.messageService.SERVER_ERROR);
        });
      }
    }
  }

  searchTicket() {
    if (this.searchTid && this.searchTid !== '') {
      const data = {
        ticketId: this.searchTid, clientId: this.clientId
      };
      this._rest.getTicketById(data).subscribe((res1) => {
        this.respObject = res1;
        // console.log(JSON.stringify(this.respObject));
        if (this.respObject.success) {
          this.gridObj4.getSelectionModel().setSelectedRanges([]);
          this.searchTid = '';
          this.addIncidentData = this.respObject.details;
        } else {
          alert(this.respObject.errorMessage);
        }
      }, (err) => {
        // this.notifier.notify('error', this.messageService.SERVER_ERROR);
      });
    } else {
      alert(this.messageService.BLANK_TICKETID);
    }
  }

  addTicket() {
    for (let i = 0; i < this.selectedTitles4.length; i++) {
      this.addedTicket.push(this.selectedTitles4[i]);
    }
    this.ticketCount = this.addedTicket.length;
  }

  onSubButtonChange(value) {
    this.subTypeId = value.value.id;
    // console.log(this.subTypeId);
  }

  onSelectGroup() {
    console.log(typeof this.userGroupSelected);
    if (this.userGroupSelected !== 0) {
      this.dialog.closeAll();
      this.userGroupId = this.userGroupSelected;
      this.onPageLoad();
    }
  }
}

@Component({
  template: `
    <div class="csat modal-header modalTitle1">
      <div class="modal-title">{{header}}</div>
    </div>
    <div class="csat modal-body modal-height pad-top-0">
      <div class="form-group">
        <textarea class="form-control radius-0 font-13" [(ngModel)]="comment" placeholder="Comment"></textarea>
      </div>
      <div class="form-group" *ngIf="type==='csat'">
        <select class="form-control radius-0 font-13 " [(ngModel)]="valSelected">
          <option *ngFor="let opt of values" [value]="opt.id">{{opt.value}}</option>
        </select>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-success radius-0" *ngIf="type==='approve'" (click)="approve('1')">Approve & Close</button>
      <button type="button" class="btn btn-danger radius-0" *ngIf="type==='approve'" (click)="approve('0')">Reject & Close</button>
      <button type="button" class="btn btn-success radius-0" *ngIf="type==='csat'" (click)="save()">Close & Save</button>
      <button type="button" class="btn btn-danger radius-0" *ngIf="type==='csat'" (click)="activeModal.close('Close click')">Cancel</button>
    </div>
  `
})
export class CSATmodalComponent implements OnInit {
  comment: string;
  values = [];
  valSelected: number;
  @Input() id;
  @Input() user_id;
  @Input() ticketId;
  @Input() type;
  @Input() cat_id;
  @Input() parent_cat_id;
  @Input() groupId;
  @Input() selectedUserID;
  @Input() header;
  @Input() seq;

  private respObject: any;

  constructor(public activeModal: NgbActiveModal, private _rest: RestApiService, private messageService: MessageService) {

  }

  ngOnInit(): void {
    if (this.type === 'csat') {
      for (let i = 1; i <= 10; i++) {
        this.values.push({ id: i, value: i });
      }
      this.valSelected = 1;
    }
  }

  save() {

    const data = {
      comm: this.comment,
      scrore: this.valSelected,
      id: this.id,
      ticketId: this.ticketId,
      user_id: this.user_id,
      ticket_type_seq: this.seq
    };
    console.log(JSON.stringify(data));
    this._rest.updateTicketStatusWithClose(data).subscribe((res1) => {
      this.respObject = res1;
      console.log(JSON.stringify(this.respObject));
      if (this.respObject.success) {
        alert('Ticket Closed Successfully');
        // this.statusName = this.status[this.statusIndex].name;
        // this.statusClick();
        this.activeModal.close();
      } else {
        alert(this.respObject.errorMessage);
      }
    }, (err) => {
      alert(this.messageService.SERVER_ERROR);
    });
  }

  approve(isApproved) {
    console.log(this.comment);
    if (this.comment === undefined || this.comment === '') {
      alert(this.messageService.BLANK_COMMENT);
    } else {
      const data = {
        id: this.ticketId,
        supportGroupLevelId: this.groupId,
        createdBy: this.user_id,
        user_id: this.selectedUserID,
        cat_id: this.cat_id,
        parent_cat_id: this.parent_cat_id,
        WFCClientResultId: this.id,
        appr_remarks: this.comment,
        isApproveTicket: isApproved
      };
      console.log(JSON.stringify(data));
      this._rest.approveProblemTicket(data).subscribe((res) => {
        this.respObject = res;
        // console.log(JSON.stringify(this.respObject))
        if (this.respObject.success) {
          this.activeModal.close();
        } else {
          alert(this.respObject.errorMessage);
        }
      }, (err) => {
        alert(this.messageService.SERVER_ERROR);
      });
    }
  }
}
